/**
 * Check if an error is a NotAllowedError from the browser.
 * This occurs when the browser blocks autoplay (e.g. second tab, no user interaction).
 */
export function isNotAllowedError(error: unknown): boolean {
  if (error instanceof DOMException && error.name === "NotAllowedError") return true;
  if (error instanceof Error && error.name === "NotAllowedError") return true;
  return (
    typeof error === "object" &&
    error !== null &&
    "name" in error &&
    (error as { name?: string }).name === "NotAllowedError"
  );
}
